import { render } from "./SmsSettings.vue?vue&type=template&id=2fb42da6"
import script from "./SmsSettings.vue?vue&type=script&lang=js"
export * from "./SmsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__